import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';

import { provideServiceRequestFeature } from '../service-request/service-request.module';

export const MEDIA_GALLERY_ROUTES: Routes = [
  {
    path: 'service-requests/media-gallery',
    // `redirectTo: 'service-requests?tab=gallery'` silently drops the query
    // string (Angular's string-based redirect only carries path segments),
    // so the tab param must be attached via an explicit UrlTree instead.
    redirectTo: () =>
      inject(Router).createUrlTree(['/service-requests'], { queryParams: { tab: 'gallery' } }),
    pathMatch: 'full',
  },
  {
    path: 'service-requests/:requestId/media-review',
    // The rework dialog opened from this page still dispatches through the
    // shared service-request NgRx store, so its feature state must be provided.
    providers: [provideServiceRequestFeature()],
    loadComponent: () => import('./pages/media-review/media-review').then((m) => m.MediaReview),
    data: {
      layout: {
        activeItem: 'Service Request',
        breadcrumb: 'Service Requests > Media Gallery > AI Validation',
        title: 'Media AI Validation Review',
        subtitle: 'Review before and after photos of this service request',
        showToolbar: false,
        backTo: '/service-requests?tab=gallery',
      },
    },
  },
];
